export enum OrderByDirectionEnum {
  DESC = 'Highest first',
  ASC = 'Lowest first',
}

export const TIME_UNIT = 'TIME_UNIT'
